// extracted by mini-css-extract-plugin
export var orderDetails = "_r8-2";
export var orderImage = "_r8-1";
export var orderMeta = "_r8-3";
export var orderSummary = "_r8-0";
export var rightArrow = "_r8-4";